import {
  Module,
  VuexModule,
  Action,
  Mutation,
  getModule
} from 'vuex-module-decorators'
import Vue from 'vue'
import axios from 'axios'

import store from '@/store'
import dashboardModule from '@/store/dashboard'
import listModule from '@/store/list'
import whitelabelModule from '@/store/whitelabel'
import { Beacon, BeaconDeal } from '@/types/Beacon'
import { Whitelabel } from '@/types/Whitelabel'

const name = 'beacon'

@Module({
  namespaced: true,
  dynamic: true,
  name,
  store
})
class BeaconModule extends VuexModule {
  private currentBeacon?: Beacon
  private allBeacons: Beacon[] = []
  private allBeaconDeals: BeaconDeal[] = []

  private get whitelabel(): Whitelabel {
    return whitelabelModule.whitelabel
  }

  get beacon(): Beacon | undefined {
    return this.currentBeacon
  }

  get beacons(): Beacon[] {
    return this.allBeacons
  }

  get beaconDeals(): BeaconDeal[] {
    return this.allBeaconDeals
  }

  @Mutation
  setCurrentBeacon(payload: Beacon) {
    Vue.set(this, 'currentBeacon', payload)
  }

  @Mutation
  setAllBeacons(payload: Beacon[]) {
    Vue.set(this, 'allBeacons', payload)
  }

  @Mutation
  setAllBeaconDeals(payload: BeaconDeal[]) {
    Vue.set(this, 'allBeaconDeals', payload)
  }

  @Action({ rawError: true })
  async fetch(id: string) {
    try {
      const { data } = await axios.get(
        `/admin/${this.whitelabel.slug}/beacon/${id}`
      )
      this.context.commit('setCurrentBeacon', data)
    } catch (error) {
      dashboardModule.newError('Beacon konnte nicht geladen werden')
    }
  }

  @Action({ rawError: true })
  async fetchAll(params: {
    limit: number
    q?: string
    page?: number
    sortBy?: string
    sortDesc?: boolean
  }) {
    try {
      const { data } = await axios.get(
        `/admin/${this.whitelabel.slug}/beacon/list`,
        {
          params
        }
      )
      this.context.commit('setAllBeacons', data.beacons)
    } catch (error) {
      dashboardModule.newError('Beacons konnten nicht geladen werden')
    }
  }

  @Action({ rawError: true })
  async fetchAllDeals(params: {
    limit: number
    venueId: string
    page?: number
  }) {
    try {
      const { data } = await axios.get(
        `/admin/${this.whitelabel.slug}/beacon/deals`,
        {
          params
        }
      )
      this.context.commit('setAllBeaconDeals', data.beaconDeals)
    } catch (error) {
      dashboardModule.newError('Deals konnten nicht geladen werden')
    }
  }

  @Action({ rawError: true })
  async create(beacon: any) {
    try {
      const { data } = await axios.post(
        `/admin/${beacon.whitelabel}/beacon`,
        beacon
      )
      this.context.commit('setCurrentBeacon', data)
      this.fetchAll({ limit: listModule.perPage })
      dashboardModule.newMessage('Beacon wurde erfolgreich erstellt')
    } catch (error) {
      dashboardModule.newError('Beacon konnte nicht erstellt werden')
    }
  }

  @Action({ rawError: true })
  async createDeal(payload: {
    whitelabel: string
    beaconDeal: Partial<BeaconDeal>
  }) {
    try {
      const { data } = await axios.post(
        `/admin/${payload.whitelabel}/beacon/deals`,
        payload.beaconDeal
      )
      this.context.commit('setCurrentBeacon', data)
      dashboardModule.newMessage('Deal wurde erfolgreich erstellt')
    } catch (error) {
      dashboardModule.newError('Deal konnte nicht erstellet werden')
    }
  }

  @Action({ rawError: true })
  async update(beacon: Partial<Beacon>) {
    try {
      const { data } = await axios.put(
        `/admin/${beacon.whitelabel}/beacon/${beacon._id}`,
        beacon
      )
      this.context.commit('setCurrentBeacon', data.beacon)
      this.fetchAll({ limit: listModule.perPage })
      dashboardModule.newMessage('Beacon wurde erfolgreich aktualisiert')
    } catch (error) {
      dashboardModule.newError('Beacon konnte nicht aktualisiert werden')
    }
  }

  @Action({ rawError: true })
  setBeacon(payload: Beacon) {
    this.context.commit('setCurrentBeacon', payload)
  }
}

export default getModule(BeaconModule)
